<template>
  <div class="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-900">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <img class="mx-auto h-12 w-auto" src="../assets/app-logo.svg" alt="Workflow" />
      <h2 class="mt-6 text-center text-3xl font-extrabold text-white">
        Password reset
      </h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">

        <div v-if="expired" class="flex flex-col text-gray-700 gap-4 text-sm">
          <div>Your password reset link has expired. Please request another password reset.</div>
          <button @click.prevent="$router.push('/')" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              Restart
          </button>
        </div>

        <div v-else-if="used" class="flex flex-col text-gray-700 gap-4 text-sm">
          <div>This password reset link is no longer valid. Please request another password reset.</div>
          <button @click.prevent="$router.push('/')" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              Restart
          </button>
        </div>

        <div v-else-if="done" class="flex flex-col text-gray-700 gap-4 text-sm">
          <div>Your password has been set succesfully.</div>
          <button @click.prevent="$router.push('/')" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              Done
          </button>
        </div>

        <form class="space-y-6" @submit.prevent="submit" v-else-if="ready">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <div class="mt-1">
              <input id="email" name="email" type="email" v-model="email" autocomplete="email" readonly class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-gray-100 text-gray-500" />
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">
              Password
            </label>
            <div class="mt-1">
              <input id="password" name="password" type="password" v-model="password" autocomplete="current-password" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
            </div>
          </div>

          <p v-if="error" class="mt-2 text-xs text-red-600" id="email-error">{{error}}</p>


          <div>


            <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              Set New Password
            </button>
          </div>
        </form>


      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import router from '../router'
// import { CheckCircleIcon } from '@heroicons/vue/outline';
7

export default {
  components: {
    // CheckCircleIcon
  },
  data: function() {
    return {
      email: '',
      password: '',
      error: null,
      expired: false,
      used: false,
      ready: false,
      done: false,
      token: ''
    }
  },
  async mounted() {
    var token = this.$route.params.token
    const split = token.split('.')
    if (split.length != 3) {
      router.push('/')
    }

    try {
      const t = JSON.parse(atob(split[1]))
      this.expired = new Date() >  new Date(t.exp * 1000)
      if (!this.expired) {
        this.token = token
        this.email = t.email
      }

      try {
        await this.axios.post('/checkforgotpassword', { token: this.token })
        this.ready = true
      }
      catch (e) {
        if (e.response && e.response.status == 409) { this.used = true }
        else { router.push('/') }
      }
    }
    catch {
      router.push('/')
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['login']),
    submit: async function() {
      if (!this.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/)) {
        this.error = 'The password be at least 8 characters long, and contain 1 lower case letter, 1 upper case letter and 1 digit'
        return
      }

      try {
        await this.axios.post('/setpassword', { token: this.token, password: this.password })
        this.done = true
      }
      catch {
        this.used = true
      }
    }
  }
}
</script>